import InfoIcon from "@mui/icons-material/Info";
import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import { trackEvent } from "src/Amplitude";
import useVerificationNavigation from "src/components/common/useVerificationNavigation";
import { VerificationBannerStyles } from "src/components/core/styles/VerficationBannerStyles";
import CnBLadySVG from "src/icons/CnBLadySVG";
import usePermission from "src/utils/hooks/usePermission";

export function TargetOrderVerificationBanner() {
  const { userPermission } = usePermission();
  const classes = VerificationBannerStyles();
  const { handleVerification } = useVerificationNavigation();

  useEffect(() => {
    const isGuest = userPermission === "guest" || userPermission === "";
    if (isGuest) trackEvent("Guest Viewed Target Order Verification Banner");
  }, []);

  const handleClick = () => {
    handleVerification();
  };
  return (
    <>
      <Box style={{ padding: "24px" }}>
        <Grid
          container
          item
          style={{
            background: "#fff6f6",
            paddingLeft: "16px",
            paddingRight: "16px",
            borderRadius: "10px",
            marginBottom: "28px",
          }}>
          <Grid
            item
            xs={12}
            style={{
              marginTop: "25px",
            }}>
            <Stack direction="row" spacing={1} alignItems={"center"}>
              <InfoIcon />
              <Typography
                style={{
                  fontWeight: 600,
                  fontSize: "18px",
                }}>
                Action on account required
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={8} style={{ marginTop: "14px" }}>
            <Typography>
              Please verify your account to access this feature. Verifying your account will allow
              you to deposit funds and make a trade/target order.{" "}
            </Typography>
          </Grid>
          <Grid
            item
            xs={4}
            style={{
              marginTop: "16px",
              textAlign: "right",
              paddingBottom: "25px",
            }}>
            <CnBLadySVG height={"100px"} width={"86px"} />
          </Grid>
        </Grid>
        <Button
          disableRipple
          onClick={handleClick}
          sx={{ height: "35px" }}
          className={classes.button}>
          Verify Account
        </Button>
      </Box>
    </>
  );
}
